import './Form.scss';

import React from 'react';
import PropTypes from 'prop-types';

const Form = ({children, className}) => (
    <form className={`c-form ${className || ''}`}
          onSubmit={(e) => {
              e.preventDefault();
          }}>
        {children}
    </form>
);

Form.propTypes = {
    className: PropTypes.string
};

export default Form;



// WEBPACK FOOTER //
// ./src/_components/FormComponents/Form/index.js